export default __webpack_public_path__ + "static/media/doc2.8bb05d7e.jpg";